import { createApi } from '@reduxjs/toolkit/query/react';
// eslint-disable-next-line import/no-cycle
import baseQueryWithReauth from './baseQuery';

export const tagTypes = [
  'Product',
  'Discount',
  'PaymentMethods',
  'User',
  'Transaction',
  'Notification',
  'Cart',
];

// Define our single API slice object
const apiSlice = createApi({
  // The cache reducer expects to be added at `state.api` (already default - this is optional)
  reducerPath: 'api',
  // Base query handles auth needs (cookies, local storage, etc)
  baseQuery: baseQueryWithReauth,
  // Delete unused data for security reasons
  keepUnusedDataFor: 0,
  // Tags for automated re-fetching
  tagTypes,
  // Endpoints are defined in features/{feature-name}/services
  endpoints: () => ({}),
});

export default apiSlice;
